import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

//import { QueryClient, QueryClientProvider } from "react-query";


ReactDOM.render(
  <React.StrictMode>
    <App />  
    {/* <Loader /> */}
  </React.StrictMode>,
  document.getElementById('root')
);